import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { makeStyles } from '@material-ui/core/styles'
import MaterialDialog from '@material-ui/core/Dialog'
import IconButton from '@material-ui/core/IconButton'
import CloseIcon from '@material-ui/icons/Close'

const useStyles = makeStyles(theme => ({
  closeButton: {
    position: 'absolute',
    top: '0px',
    right: '0px',

    [theme.breakpoints.down('xs')]: {
      top: '4px',
      right: '4px',
    },

    '& .MuiSvgIcon-root': {
      width: '24px',
      height: '24px',

      [theme.breakpoints.down('xs')]: {
        width: '20px',
        height: '20px',
      },
    },
  },
}))

const Dialog = (props) => {
  const {
    children,
    trigger,
    isOpen,
    showCloseButton,
    fullScreen,
    maxWidth,
    onClose,
    onOpen,
  } = props

  const styles = useStyles()

  const [_isOpen, _setIsOpen] = useState(false)
  const openDialog = () => _setIsOpen(true)
  const closeDialog = () => {
    _setIsOpen(false)
    if (onClose != null) {
      onClose()
    }
  }

  const DialogCloseButton = () => (
    <IconButton aria-label="close" className={styles.closeButton} onClick={closeDialog}>
      <CloseIcon />
    </IconButton>
  )

  // control open state either from external prop or internal state
  // (prefer external prop, if provided)
  const open = isOpen != null ? isOpen : _isOpen

  useEffect(() => {
    if (open && onOpen) {
      onOpen()
    }
  }, [open])

  return (
    <>
      {trigger && <trigger.type {...trigger.props} onClick={openDialog} />}
      <MaterialDialog
        open={open}
        onClose={closeDialog}
        maxWidth={maxWidth}
        fullScreen={fullScreen}
      >
        <>
          {showCloseButton && <DialogCloseButton onClick={closeDialog} />}
          {children({ closeDialog })}
        </>
      </MaterialDialog>
    </>
  )
}

Dialog.propTypes = {
  children: PropTypes.func.isRequired,
  trigger: PropTypes.element,
  isOpen: PropTypes.bool,
  showCloseButton: PropTypes.bool,
  fullScreen: PropTypes.bool,
  maxWidth: PropTypes.string,
  onClose: PropTypes.func,
  onOpen: PropTypes.func,
}

Dialog.defaultProps = {
  showCloseButton: false,
  fullScreen: false,
  maxWidth: 'sm',
}

export default Dialog
